import React, { useEffect, useState } from "react";
import Form from "olive-react-myoneui/lib/Form";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import "react-phone-input-2/lib/style.css";
import { Button, Toast, ToastInfo } from "olive-react-myoneui";
import { getProfileFieldBlocks, updateProfileFields } from "../../../../api/afterLogin/learners";
import { useSelector } from "react-redux";
import { Card } from "olive-react-myoneui";
import NoItems from "./NoItems";

const AdditionalDetails = () => {
  const configData = useSelector((state) => state.config);
  const [profileFieldBlocks, setProfileFieldBlocks] = useState({});
  const learnerData = useSelector((state) => state.user.user);
  const [profileFieldValue, setProfileFieldValue] = useState({});
  const [successToast, setSuccessToast] = useState(false);

  const learnerProfileFields =
    configData.session.us_profile_fields;

  const profileFields = learnerProfileFields && learnerProfileFields !== null ? learnerProfileFields.split("{#}") : false;
  const userProfileFieldData = {};
  if (profileFields) {
    profileFields.forEach((field) => {
      field = field.substring(2, field.length - 2);
      if (field != "{=>}") {
        const tempField = field.split("{=>}");
        const key = tempField[0] || 0;
        const value = tempField[1] || "";
        userProfileFieldData[key] = value;
      }
    });
  }

  const loadProfileFieldBlocks = async () => {
    const profileProfileblocks = await getProfileFieldBlocks(
      configData.access_token
    );
    if (profileProfileblocks) {
      setProfileFieldBlocks(profileProfileblocks);
    }
  };

  const handleSubmit = async (e, blockId) => {
    e.preventDefault();
    let blockDefaultFieldValue = {};
    if (Object.keys(profileFieldValue).length === 0 && Object.keys(profileFieldBlocks).length > 0) {
      Object.values(profileFieldBlocks).forEach((block) => {
        block.profile_fields.forEach((block_pf) => {
          blockDefaultFieldValue[block.id] = {
            ...blockDefaultFieldValue[block.id],
            [block_pf.pf_name]: userProfileFieldData[block_pf.id] ?? "",
          };
        });
      });
    }
    
    const blockValue = Object.keys(profileFieldValue).length === 0 && Object.keys(blockDefaultFieldValue).length > 0 ? blockDefaultFieldValue[blockId] : Object.keys(profileFieldValue).length > 0 ? profileFieldValue[blockId] : '';
    
    if (blockValue) {
      try {
        const response = await updateProfileFields(configData.access_token, blockValue);

        if(response.status === 200) {
          setSuccessToast(true);
        }
      } catch(err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    loadProfileFieldBlocks();
  }, []);

  return (
    <>
      <Row>
        <div style={{ display: successToast ? "block" : "none" }}>
          <Toast variant="primary" className="mb-2 mt-2">
            <Toast.Body>
              <ToastInfo toastDescription="Profile fields has been updated successfully." />
              <div className="action-wrapper">
                <Button
                  variant="primary"
                  type="button"
                  size="sm"
                  className="btn-round bg-primary-fade"
                  aria-label="Close"
                  onClick={() => setSuccessToast(false)}
                >
                  Close
                </Button>
              </div>
            </Toast.Body>
          </Toast>
        </div>

        {profileFieldBlocks && Object.keys(profileFieldBlocks).length > 0 && Object.values(profileFieldBlocks).map((block) => (
          <Card className="border-0 mb-4">
            <Card.Body className="p-0">
              <h3 className="mb-3">
                <strong>{block.pb_name}</strong>
              </h3>
              <Form onSubmit={(e) => handleSubmit(e, block.id)}>
                <Row>
                  {block.profile_fields.map((block_pf) => {
                    return (
                      <>
                        <Col xl="6">
                          <Form.Group
                            className="mb-3"
                            controlId={block_pf.pf_name}
                            label={block_pf.pf_label}
                          >
                            <Form.Label>{block_pf.pf_label} {block_pf.pf_mandatory === "1" && <span style={{ color: "red" }}> *</span>}</Form.Label>
                            {block_pf.pf_field_input_type == 1 ? (
                              <Form.Control
                                type="text"
                                placeholder={block_pf.pf_placeholder}
                                name={block_pf.pf_name}
                                defaultValue={
                                  userProfileFieldData[block_pf.id] ?? ""
                                }
                                onChange={(e) =>
                                  setProfileFieldValue({
                                    ...profileFieldValue,
                                    [block.id]: {
                                      ...profileFieldValue[block.id],
                                      [block_pf.pf_name]: e.target.value,
                                    },
                                  })
                                }
                                required={block_pf.pf_mandatory == 1}
                                disabled={block_pf.pf_azure_custom_field == 1}
                              />
                            ) : (
                              <div className="myk_stu-dropdown-default">
                              <div className="myk_stu-selectdrop">
                              <Form.Select
                                aria-label="Default select example"
                                disabled={block_pf.pf_azure_custom_field == 1}
                                required={block_pf.pf_mandatory == 1}
                                style={{ color: "#000", padding: "10px 15px" }}
                                onChange={(e) =>
                                  setProfileFieldValue({
                                    ...profileFieldValue,
                                    [block.id]: {
                                      ...profileFieldValue[block.id],
                                      [block_pf.pf_name]: e.target.value,
                                    },
                                  })
                                }
                              >
                                <option value="">{`Choose ${block_pf.pf_label}`}</option>
                                {block_pf.pf_default_value
                                  .split(",")
                                  .map((defaultValue) => {
                                    const fieldValue =
                                      userProfileFieldData[block_pf.id] ?? "";
                                    const selected =
                                      fieldValue === defaultValue
                                        ? true
                                        : false;
                                    return (
                                      <option
                                        value={defaultValue}
                                        selected={selected}
                                      >
                                        {defaultValue}
                                      </option>
                                    );
                                  })}
                                ;
                              </Form.Select>
                              <div className="caret-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="6.119"
                                  height="11.658"
                                  viewBox="0 0 6.119 11.658"
                                >
                                  <path
                                    id="Path_21616"
                                    data-name="Path 21616"
                                    d="M0,0,4.42,3.71,8.84,0"
                                    transform="translate(1.409 10.249) rotate(-90)"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                  />
                                </svg>
                              </div>
                              </div>
                              </div>
                            )}
                            <p className="help-text">
                              {block_pf.pf_purpose_field}
                            </p>
                          </Form.Group>
                        </Col>
                      </>
                    );
                  })}
                  <div className="action-btns mt-2 text-end">
                    <Button variant="primary" type="submit">
                      Save changes
                    </Button>
                  </div>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        ))}
        {!profileFieldBlocks || Object.keys(profileFieldBlocks).length == 0 && (
          <NoItems />
        )}
      </Row>
    </>
  );
};

export default AdditionalDetails;
